EventBus.subscribe('init-modules', function () {

    
    jQuery('form.validate').each(function () {
        
        var
            currentForm = jQuery(this),
            input,
            rules = {}
        ;

        //Apply validator to form
        currentForm.data('validator', currentForm.validate({
            errorClass: 'input-error',
            validClass: 'valid',
            errorPlacement: function (error, element) {
                return;
            },
            ignore: '',
            rules: rules,
            invalidHandler: function (form, validator) {
                currentForm.addClass('was-validated');
            },
            submitHandler: function (form) {
                if (currentForm.attr('action')) {
                    //Carry out default form submit if an action attribute is present
                    form.submit();
                }

                if (currentForm.data('show-errors')) {

                    let errorsContainer = jQuery(currentForm.data('show-errors'));

                    if (errorsContainer.length === 0) {
                        return;
                    }
                    errorsContainer.html('');
                }

                if (currentForm.hasClass('handle-form-file-upload')) {
                    currentForm.trigger('handle-uploads', [form]);
                }
                else {
                    //Trigger success event on form to be received in module
                    currentForm.trigger('form-success');
                }
            }
        }));
        
    });
});